import { l2rApps } from "../constants/l2rApps"

export function replaceSearchParams(params, acceptedParams) {
    return (params || "")
        .replaceAll("?", "")
        .split("&")
        .filter(search => {
            return acceptedParams.some(param => {
                return search.split("=")[0] === param
            })
        })
        .reduce((acc, v, index) => {
            return index === 0 ? `?${v}` : `${acc}&${v}`
        }, "")
}

export function cleanInnerPath(path, app) {
    if (!l2rApps[app] || !l2rApps[app].innerPathCleaner) {
        return path
    }
    return l2rApps[app].innerPathCleaner(path)
}